



























import Vue from 'vue'
import SimpleModalBox from '@/components/modal/basics/SimpleModal/SimpleModalBox.vue'

export default Vue.extend({
  components: {
    SimpleModalBox,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    withoutBackdrop: {
      type: Boolean as () => boolean,
      default: false,
    },
    contentTransition: {
      type: Object,
      default: () => {
        return {
          name: 'modal-content-simple',
        }
      },
    },
  },
})
